import styled from 'styled-components';
import { OffCanvasBodyProps } from './OffCanvasBody';

export const Element = styled.div<OffCanvasBodyProps>`
  padding: ${({ theme }) => theme.spacing.base};
  flex-grow: 1;
  overflow-x: auto;
`;
